'use client'

import type { ReactNode } from 'react'
import { SharedSurfaceProvider, type SharedSurface } from '@/deskUiSkeletons/Shared/SharedSurfaceContext'
import { MsgDeskLoading } from '../MsgDeskLoading'
import { siteSharedSkin } from './SharedSkin'

const siteSharedSurface: SharedSurface = {
  Loading: MsgDeskLoading,
  skin: siteSharedSkin,
}

export function SiteSharedSurfaceProvider({ children }: { children: ReactNode }) {
  return <SharedSurfaceProvider value={siteSharedSurface}>{children}</SharedSurfaceProvider>
}
